function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.751 6.368l20.541-4.366M13.6.783l-4.4.935A1.5 1.5 0 008.042 3.5l.312 1.468 7.336-1.56-.312-1.467A1.5 1.5 0 0013.6.783zM10.751 18v-7.5m4.5 7.5v-7.5M18.626 6h2.625l-1.385 15.874a1.5 1.5 0 01-1.5 1.376H7.631a1.5 1.5 0 01-1.494-1.376L5.1 9.377",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgBin2Alternate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref);
}

export default SvgBin2Alternate;